module.exports = __webpack_public_path__ + "img/dementia-05-risk-factor.71ddf439.jpg";